import {announce} from '@react-aria/live-announcer'
import {addIntegration, tanstackRouterBrowserTracingIntegration} from '@sentry/react'
import {Toaster} from 'sonner'

import AuthEffects from '@/auth/components/AuthEffects'
import {loadSentryIntegrations} from '@/instrument'
import BookmarkUpdater from '@/lib/bookmark/components/BookmarkUpdater'
import CartUpdater from '@/lib/cart/components/CartUpdater'
import LocaleUpdater from '@/lib/locale/components/LocaleUpdater'
import ThemeEffects from '@/lib/theme/ThemeEffects'
import {CssVariableEffects} from '@/utils/components/CssVariableChange'
import RouteAnnouncer from '@/utils/router/RouteAnnouncer'

import {DEBUG} from './constants/config'
import InAppEffects from './lib/in-app/InAppEffects'
import isInApp from './lib/in-app/utils/isInApp'
import ReloadIfNotUsingStripeAnymore from './lib/payment/components/ReloadIfNotUsingStripeAnymore'

const GoogleOneTapLogin = lazy(async () => await import('@/auth/components/GoogleOneTapLogin'))

export default memo(function Global() {
  const router = useRouter()

  useEffect(function initLiveAnnouncer() {
    // fixes for https://github.com/adobe/react-spectrum/issues/5191
    announce(' ', 'polite', 0)
  }, [])

  useEffect(
    function addSentryIntegration() {
      if (DEBUG) return
      addIntegration(tanstackRouterBrowserTracingIntegration(router))
      loadSentryIntegrations()
    },
    [router],
  )

  return (
    <>
      <InAppEffects />
      <LocaleUpdater />
      <ThemeEffects />
      <CssVariableEffects />
      <Toaster richColors />
      <AuthEffects />
      <BookmarkUpdater />
      <CartUpdater />
      <RouteAnnouncer />
      <ReloadIfNotUsingStripeAnymore />
      {!isInApp() && (
        <Suspense>
          <GoogleOneTapLogin />
        </Suspense>
      )}
    </>
  )
})
